import React from 'react'
import Datepicker from '../Datepicker';

export type DatePickerColorProps = {
  Istyles: React.CSSProperties,
  IboxStyles?: React.CSSProperties,
  IfillColor: string
}

export function BlueDatePickerProperties() {

  const Istyles: React.CSSProperties = {
    backgroundColor: "#FFFFFF",
    border: "1px solid #243165",
    borderLeft: "none",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
  }

  const IboxStyles: React.CSSProperties = {
    backgroundColor: "#FFFFFF",
    border: "1px solid #243165",
    borderRight: "none",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
  }

  const IfillColor = "#243165";

  const propiedades: DatePickerColorProps = {
    Istyles,
    IboxStyles,
    IfillColor
  }

  return propiedades;
}


export default function DatePickerBlueColor({ ...props }) {



  return (
    <Datepicker
      {...BlueDatePickerProperties()}
      {...props}
    />
  )
}
